import type { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { easeOutCubic, animationDuration } from '../constants';
import { Grid } from '@simplywallst/ui-core';
import type { TransitionStatus } from 'react-transition-group';

export interface SheetLayout {
  top?: CSSProperties['top'];
  left?: CSSProperties['left'];
  right?: CSSProperties['right'];
  width?: CSSProperties['width'];
  'max-width'?: CSSProperties['maxWidth'];
  height?: CSSProperties['height'];
}

interface Props {
  zIndex: number;
  transitionStatus: TransitionStatus;
  sheetLayout?: SheetLayout;
}

export const StyledSheet = styled(Grid)<Props>`
  position: fixed;
  overflow-x: hidden;
  width: 100%;
  bottom: 0;
  height: ${({ theme }) => `calc(
    100vh - ${theme.safeAreaInsetTop} - ${theme.safeAreaInsetBottom}
  )`};
  z-index: ${({ zIndex }) => zIndex};
  ${({ sheetLayout, theme }) => {
    if (typeof sheetLayout === 'undefined') {
      return css`
        top: 0;
        left: max(0px, calc(50vw - 443px));
        height: calc(
          100dvh - ${theme.safeAreaInsetTop} - ${theme.safeAreaInsetBottom}
        );
        max-width: 886px;
      `;
    }
    let templateLiteral = ``;
    Object.entries(sheetLayout).forEach((n) => {
      templateLiteral += `
         ${n[0]}: ${n[1]};
        `;
    });
    return templateLiteral;
  }}
  touch-action: none;
  /* Default */
  transform: translate3d(0, 101%, 0);

  /* Transitions */
  /* we prefer to use transition: all but it takes effect on z-index
      which causes a flash if zIndex prop changes.
      The next best thing is to unify portal where z-index can be managed.
   */

  ${({ sheetLayout }) => {
    let transitionLiteral = `transition: transform ${
      animationDuration / 1000
    }s ${easeOutCubic}`;
    Object.entries(sheetLayout || {}).forEach((n) => {
      transitionLiteral += `, ${n[0]} ${
        animationDuration / 1000
      }s ${easeOutCubic}`;
    });
    return transitionLiteral + ';';
  }}

  ${({ transitionStatus }) => {
    if (transitionStatus === 'entered' || transitionStatus === 'entering') {
      return 'transform: translate3d(0, 0%, 0);';
    }
  }}
`;
